import { Skeleton } from "@mui/material";

const CreateSkeleton = () => {
    return (
        <>
            <div className="col-span-6 flex flex-col gap-y-[8px]">
                <Skeleton variant="text" sx={{ fontSize: "1rem" }} width={"15%"} />
                <Skeleton variant="rounded" width={"100%"} height={38} />
            </div>
            <div className="col-span-6 flex flex-col gap-y-[8px]">
                <Skeleton variant="text" sx={{ fontSize: "1rem" }} width={"15%"} />
                <Skeleton variant="rounded" width={"100%"} height={38} />
            </div>
            <div className="col-span-6 flex flex-col gap-y-[8px]">
                <Skeleton variant="text" sx={{ fontSize: "1rem" }} width={"15%"} />
                <Skeleton variant="rounded" width={"100%"} height={38} />
            </div>
            <div className="col-span-6 flex flex-col gap-y-[8px]">
                <Skeleton variant="text" sx={{ fontSize: "1rem" }} width={"15%"} />
                <Skeleton variant="rounded" width={"100%"} height={38} />
            </div>
            <div className="col-span-12 flex flex-col gap-y-[8px]">
                <Skeleton variant="text" sx={{ fontSize: "1rem" }} width={"15%"} />
                <Skeleton variant="rounded" width={"100%"} height={38} />
            </div>
            <div className="col-span-12 flex flex-col gap-y-[8px]">
                <Skeleton variant="text" sx={{ fontSize: "1rem" }} width={"15%"} />
                <Skeleton variant="rounded" width={"100%"} height={38} />
            </div>
            <div className="col-span-12 flex flex-col gap-y-[8px]">
                <Skeleton variant="text" sx={{ fontSize: "1rem" }} width={"15%"} />
                <Skeleton variant="rounded" width={"100%"} height={200} />
            </div>
        </>
    );
};

export default CreateSkeleton;
